module.exports = __webpack_public_path__ + "static/img/pikesi.18595631.jpg";